import { render, staticRenderFns } from "./centilliongod.vue?vue&type=template&id=b37d0098"
import script from "./centilliongod.vue?vue&type=script&lang=js"
export * from "./centilliongod.vue?vue&type=script&lang=js"
import style0 from "./centilliongod.vue?vue&type=style&index=0&id=b37d0098&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports